import { FC } from 'react';
import { Button } from 'src/components/ui/Button';
import { useNavigate } from 'react-router';
import { geoJSONToCoords, getPolygonColors } from 'src/utils/helpers';
import { useAuth } from 'src/hooks/useAuth';
import { MapContainer, Marker, Polygon, TileLayer, WMSTileLayer } from 'react-leaflet';
import { mapData, schemaTileUrl } from 'src/config/data';
import { useAppSelector } from 'src/hooks/useRedux';
import { BASE_URL } from 'src/config';
import { PolygonType } from 'src/config/types';
import { safeStringToCoords } from 'src/utils';
import L from 'leaflet';

import MarkerIcon from 'src/assets/icons/marker.svg';
import cn from 'classnames';

interface DashBoardSingleMapProps {
  polygon: PolygonType;
  classNames?: string;
}

export const DashBoardSingleMap: FC<DashBoardSingleMapProps> = ({ polygon, classNames }) => {
  const categories = useAppSelector(state => state.categories);

  const { user } = useAuth();

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/map?cn=${polygon.cadaster_number}`);
  };
  const center = safeStringToCoords(polygon?.center || polygon?.properties?.center || '');

  if (!center || !user) {
    return <></>;
  }

  const polygonMapData = {
    ...mapData,
    zoom: 16,
    center,
  };

  const myIcon = L.icon({
    iconUrl: MarkerIcon,
    popupAnchor: [0, -40],
    iconAnchor: [16, 40],
    iconSize: [32, 40],
  });

  const positions = polygon.geometry
    ? geoJSONToCoords(polygon.geometry, polygon?.center || polygon?.properties?.center)
    : [];

  const { fill, stroke, hatching } = getPolygonColors(polygon, categories, user);

  return (
    <div className={cn('w-full', classNames)}>
      <div className="w-full h-[20rem] rounded-lg overflow-hidden mb-5">
        <MapContainer {...polygonMapData} className="my-map">
          <TileLayer maxZoom={19} url={schemaTileUrl[0]} />

          <WMSTileLayer
            maxZoom={19}
            zIndex={2}
            tileSize={1024}
            url={`${BASE_URL}/api-layer/land_plots/`}
            format=""
          />

          <Marker icon={myIcon} position={center} />

          {positions?.length ? (
            <>
              <Polygon
                fillOpacity={0.5}
                positions={positions}
                pathOptions={{
                  fillColor: fill,
                  stroke: false,
                }}
              />
              <Polygon
                fillOpacity={1}
                positions={positions}
                pathOptions={{
                  color: stroke,
                  fillColor: `url(#pattern-${hatching.replace('#', '')})`,
                }}
              />
            </>
          ) : null}
        </MapContainer>
      </div>

      <Button variant="blue" size="big" classNames="w-full text-center" onClick={handleClick}>
        Перейти к объекту на карте
      </Button>
    </div>
  );
};
